module.exports = __webpack_public_path__ + "static/media/map.5a0400ca.png";